import React, { useContext, useState, useEffect, useRef } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../../components/FormInput";
import { validationRules, validateDOB } from "../../../utils/validationRules";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  createDoctorLoan,
  getDoctorLoanByEmail,
  getAllCities,
  getDoctorLoanByMobile,
  getAllStates,
  getAllPincode,
  getDoctorLoanBankList,
  createOrGetCustomer
} from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../../assets/logo.png";
import SelectInput from "../../../components/SelectInput";
import DropDownInput from "../../../components/DropDownInput";
import { FaTrashAlt } from "react-icons/fa";


const CreateDoctorForm = () => {
  const { adminId, adminName, isLoggedIn, adminRole } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [presentState, setPresentState] = useState(null);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [clinicState, setClinicState] = useState(null);
  const [clinicCityOptions, setClinicCityOptions] = useState([]);
  const [clinicPincodeOptions, setClinicPincodeOptions] = useState([]);
  const [hospitalState, setHospitalState] = useState(null);
  const [hospitalCityOptions, setHospitalCityOptions] = useState([]);
  const [hospitalPincodeOptions, setHospitalPincodeOptions] = useState([]);
  const [doctorLoanBanks, setDoctorLoanBanks] = useState([]);
  const [files, setFiles] = useState({});

  const navigate = useNavigate();
  const methods = useForm({ mode: "onChange", reValidateMode: "onChange" });
  const {
    handleSubmit,
    register,
    watch,
    trigger,
    setValue,
    formState: { errors, isValid },
  } = methods;
  const [emailExists, setEmailExists] = useState(false);
  const [mobileExists, setMobileExists] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  const fileRefs = {
    pan_card: useRef(null),
    aadhar_card: useRef(null),
    photo: useRef(null),
    payslip: useRef(null),
    salaried_account_statement: useRef(null),
    itr: useRef(null),
    degree_certificate: useRef(null),
    others: useRef(null),
    ima_certificate: useRef(null),
    clinic_registration_certificate: useRef(null),
  };

  const steps = ["Personal Details", "Clinic Details", "Upload Documents"];

  const handleStepChange = async (newStep) => {
    if (newStep > activeStep) {
      const isValid = await trigger();
      if (isValid) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }

        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }

        setActiveStep(newStep);
      }
    } else {
      setActiveStep(newStep);
    }
  };

  useEffect(() => {
    const fetchDoctorLoanBanks = async () => {
      try {
        const response = await getDoctorLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setDoctorLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching doctor loan banks:", error);
      }
    };
    fetchDoctorLoanBanks();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        setCities(citiesData);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincode(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCityOptions([]);
      setPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );

      const cityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setCityOptions(cityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPincodeOptions(uniqueOptions);
    }

    if (!presentState) {
      setPresentCityOptions([]);
      setPresentPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === presentState
      );

      const presentCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setPresentCityOptions(presentCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === presentState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPresentPincodeOptions(uniqueOptions);
    }

    if (!clinicState) {
      setClinicCityOptions([]);
      setClinicPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === clinicState
      );

      const clinicCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setClinicCityOptions(clinicCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === clinicState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setClinicPincodeOptions(uniqueOptions);
    }

    if (!hospitalState) {
      setHospitalCityOptions([]);
      setHospitalPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === hospitalState
      );

      const hospitalCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setHospitalCityOptions(hospitalCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === hospitalState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setHospitalPincodeOptions(uniqueOptions);
    }
  }, [
    selectedState,
    presentState,
    clinicState,
    hospitalState,
    cities,
    pincodenumber,
  ]);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const handlePresentStateChange = (selectedOption) => {
    setPresentState(selectedOption?.value || null);
    setValue("present_state", selectedOption?.value || "");
  };

  const getSelectedPresentStateValue = () => {
    return stateOptions.find((option) => option.value === presentState);
  };

  const handleClinicStateChange = (selectedOption) => {
    setClinicState(selectedOption?.value || null);
    setValue("clinic_state", selectedOption?.value || "");
  };

  const getSelectedClinicStateValue = () => {
    return stateOptions.find((option) => option.value === clinicState);
  };

  const handleHospitalStateChange = (selectedOption) => {
    setHospitalState(selectedOption?.value || null);
    setValue("hospital_state", selectedOption?.value || "");
  };

  const getSelectedHospitalStateValue = () => {
    return stateOptions.find((option) => option.value === hospitalState);
  };


  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getDoctorLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile) {
      try {
        const data = await getDoctorLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    }
  };

  const handleNextStep = async () => {
    const isStepValid = await trigger();
    if (isStepValid) {
      if (emailExists) {
        toast.error("Email already exists. Please use a different email.");
        return;
      }
      if (mobileExists) {
        toast.error(
          "Mobile number already exists. Please use a different mobile number."
        );
        return;
      }
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files.length > 0) {
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const mobile = localStorage.getItem("verifiedMobile");
    const name = data.name;

    try {
      if (!isLoggedIn) {
        // Not logged in: create or get customer
        let adminId;
        let adminName = name;

        try {
          const customerResponse = await createOrGetCustomer({ mobile, name });
          adminId = customerResponse.adminId;
          adminName = customerResponse.name || name;
          // toast.info(customerResponse.isNew ? "Customer created successfully!" : "Customer already exists!");
        } catch (err) {
          throw err;
        }

        // Set created_by and created_id for the home loan
        data.created_by = adminName;
        data.created_id = adminId;
        data.status = data.status || "open";
        data.assigned_to = data.assigned_to || "";

      } else {
        data.created_by = adminName;
        data.created_id = adminId;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (
          key === "pan_card" ||
          key === "aadhar_card" ||
          key === "photo" ||
          key === "payslip" ||
          key === "salaried_account_statement" ||
          key === "itr" ||
          key === "degree_certificate" ||
          key === "others" ||
          key === "ima_certificate" ||
          key === "clinic_registration_certificate"
        ) {
          formData.append(key, data[key][0]);
        } else {
          formData.append(key, data[key]);
        }
      });

      const response = await createDoctorLoan(formData);
      toast.success("Doctor loan created successfully!");
      setTimeout(() => {
        navigate(isLoggedIn ? "/doctorloanlist" : "/");
      }, 2000);

    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message;
      console.error("Error submitting doctor loan:", errorMessage || error);
      toast.error("Failed to submit loan application. Please try again.");
    }
  };

  const email = watch("email");
  const mobile = watch("mobile");
  const dob = watch('dob');

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  React.useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      if (age >= 0) {
        setValue("age", age);
      } else {
        setValue("age", "");
      }
    }
  }, [dob, setValue]);

  const handleGoBack = () => {
    if (isLoggedIn) {
      navigate("/doctorloanlist");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="container">
      <div className="edit-back-icon">
        {activeStep === 0 && (
          <div className="edit-back-text" onClick={handleGoBack}>
            &lt; Go Back
          </div>
        )}
        <img src={logo} alt="Logo" className="form-logo" />
      </div>
      <h2 className="my-4">Doctor Loan</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="form-group">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="name"
                      label="Name"
                      registerOptions={validationRules.name}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="dob"
                      label="Date of Birth"
                      type="date"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: validateDOB,
                      }}
                      error={errors.dob?.message}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="age"
                      label="Age"
                      type="number"
                      readOnly
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mobile"
                      label="Mobile"
                      type="tel"
                      registerOptions={validationRules.mobile}
                      error={
                        mobileExists
                          ? "Mobile number already exists"
                          : errors.mobile?.message
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="email"
                      label="Email ID"
                      registerOptions={validationRules.email}
                      error={errors.email?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.fieldRequired(
                        "Father Name"
                      )}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.fieldRequired(
                        "Mother Name"
                      )}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="marital_status"
                      label="Marital Status"
                      options={[
                        { value: "single", label: "Single" },
                        { value: "married", label: "Married" },
                        { value: "divorced", label: "Divorced" },
                      ]}
                      registerOptions={{
                        required: "Status is required",
                        onChange: (e) => {
                          setValue("marital_status", e.target.value);
                        },
                      }}
                      error={errors.marital_status?.message}
                    />
                  </Col>
                  {watch("marital_status") === "married" && (
                    <Col md={6}>
                      <FormInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={validationRules.fieldRequired(
                          "Spouse Name"
                        )}
                        error={errors.spouse_name?.message}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <DropDownInput
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        {
                          value: "OwnedByMe/Spouse",
                          label: "OwnedByMe/Spouse",
                        },
                        {
                          value: "OwnedByMy/Parents",
                          label: "OwnedByMy/Parents",
                        },
                        { value: "Rent", label: "Rent" },
                        { value: "PG", label: "PG" },
                        { value: "Hostel", label: "Hostel" },
                        { value: "Bachelor", label: "Bachelor" },
                        { value: "Company_Provided", label: "Company Provide" },
                      ]}
                      registerOptions={{
                        required: "Residence Type is required",
                      }}
                      error={errors.residence_type?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="address"
                      label="Present Staying Address"
                      registerOptions={{
                        required: "Address is required",
                      }}
                      error={errors.address?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="landmark"
                      label="Landmark"
                      type="text"
                      registerOptions={{ required: "Landmark is required" }}
                      error={errors.landmark?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedStateValue()}
                      registerOptions={{ required: "State is required" }}
                      onChange={handleStateChange}
                      error={errors.state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="city"
                      label="District"
                      options={cityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="current_address_as_per_aadhar"
                      label="Is your Present Address as per Aadhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.current_address_as_per_aadhar?.message}
                    />
                  </Col>
                  {watch("current_address_as_per_aadhar") === "No" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="present_address"
                          label="Present Aadhaar Address"
                          registerOptions={{
                            required: "Address is required",
                          }}
                          error={errors.present_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="present_landmark"
                          label="Landmark"
                          type="text"
                          registerOptions={{
                            required: "Landmark is required",
                          }}
                          error={errors.present_landmark?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_state"
                          label="State"
                          options={stateOptions}
                          value={getSelectedPresentStateValue()}
                          onChange={handlePresentStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.present_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_city"
                          label="City"
                          options={presentCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.present_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_pincode"
                          label="Pincode"
                          registerOptions={{
                            required: "Pincode is required",
                          }}
                          options={presentPincodeOptions}
                          error={errors.present_pincode?.message}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            )}
            {activeStep === 1 && (
              <div className="sections requested-loan-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="required_loan_amount"
                      label="Required Loan Amount"
                      type="text"
                      registerOptions={validationRules.loanAmount}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="existing_emi_amount"
                      label="Existing EMI"
                      type="text"
                      registerOptions={{
                        required: "This Existing EMI is required",
                        pattern: validationRules.validNumber.pattern,
                      }}
                      error={errors.existing_emi_amount?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="degree"
                      label="Choose Degree"
                      options={[
                        { value: "MBBS", label: "MBBS" },
                        { value: "MD&Above", label: "MD & Above" },
                        { value: "Surgeon", label: "Surgeon" },
                        { value: "BDS/MDS", label: "BDS/MDS" },
                        { value: "Others", label: "Others" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.degree?.message}
                    />
                  </Col>
                  {isLoggedIn && adminRole !==  "customer" &&(
                    <Col md={6}>
                      <SelectInput
                        name="bank_name"
                        label="Bank Name"
                        options={doctorLoanBanks}
                      />
                    </Col>
                  )}
                  {watch("degree") === "MBBS" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="service_experience"
                          label="Service Experience'"
                          registerOptions={{
                            required: "Service experience is required",
                          }}
                          error={errors.spouse_name?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="mbbs_completed_year"
                          label="MBBS Completed Year"
                          type="text"
                          registerOptions={{
                            required: "MBBS Completed Year is required",
                            pattern: validationRules.validNumber.pattern,
                            validate: (value) => {
                              const currentYear = new Date().getFullYear();
                              if (
                                isNaN(value) ||
                                value < 1990 ||
                                value >= currentYear
                              ) {
                                return `Please enter a year between 1990 and ${currentYear - 1
                                  }`;
                              }
                              return true;
                            },
                          }}
                          error={errors.mbbs_completed_year?.message}
                        />
                      </Col>
                    </>
                  )}
                  {watch("degree") === "Others" && (
                    <Col md={6}>
                      <FormInput
                        name="degree_others"
                        label="Degree Others"
                        registerOptions={{
                          required: "Degree others is required",
                        }}
                        error={errors.degree_others?.message}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <DropDownInput
                      name="work_type"
                      label="Work Type?"
                      options={[
                        { value: "Salaried", label: "Salaried" },
                        { value: "Own Clinic", label: "Own Clinic" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.work_type?.message}
                    />
                  </Col>
                  {watch("work_type") === "Own Clinic" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="clinic_name"
                          label="Clinic Name"
                          registerOptions={{
                            required: "Clinic name is required",
                          }}
                          error={errors.clinic_name?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="clinic_address"
                          label="Clinic Address"
                          registerOptions={{
                            required: "Clinic addres is required",
                          }}
                          error={errors.clinic_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="clinic_state"
                          label="Clinic State"
                          options={stateOptions}
                          value={getSelectedClinicStateValue()}
                          onChange={handleClinicStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.clinic_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="clinic_city"
                          label="Clinic City"
                          options={clinicCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.clinic_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="clinic_pincode"
                          label="Clinic Pincode"
                          options={clinicPincodeOptions}
                          registerOptions={{
                            required: "Pincode is required",
                          }}
                          error={errors.clinic_pincode?.message}
                        />
                      </Col>
                    </>
                  )}
                  {watch("work_type") === "Salaried" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="hospital_name"
                          label="Working Hospital Name"
                          registerOptions={{
                            required: "Hospital name is required",
                          }}
                          error={errors.hospital_name?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="total_experience"
                          label="Total Experience"
                          registerOptions={{
                            required: "Total experience is required",
                          }}
                          error={errors.total_experience?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="net_salary"
                          label="Net Salary"
                          type="text"
                          registerOptions={{
                            required: "Net salary is required",
                            pattern: validationRules.validNumber.pattern,
                          }}
                          error={errors.net_salary?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDownInput
                          name="is_pf_deducted"
                          label="Are You Looking for Balance Transfer?"
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                          error={errors.is_pf_deducted?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="hospital_address"
                          label="Hospital Address"
                          registerOptions={{
                            required: "Hospital address is required",
                          }}
                          error={errors.hospital_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="hospital_state"
                          label="Hospital State"
                          options={stateOptions}
                          value={getSelectedHospitalStateValue()}
                          onChange={handleHospitalStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.clinic_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="hospital_city"
                          label="Hospital City"
                          options={hospitalCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.hospital_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="hospital_pincode"
                          label="Hospital Pincode"
                          options={hospitalPincodeOptions}
                          registerOptions={{
                            required: "Pincode is required",
                          }}
                          error={errors.hospital_pincode?.message}
                        />
                      </Col>
                    </>
                  )}
                  <Col md={6}>
                    <DropDownInput
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Colleague", label: "Colleague" },
                        { value: "Relative", label: "Relative" },
                      ]}
                    />
                  </Col>
                </Row>
                <Row>
                  <h4>Reference Details</h4>
                  <Col md={6}>
                    <FormInput name="reference_name" label="Name" />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="reference_mobile"
                      label="Mobile"
                      type="tel"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput name="reference_address" label="Address" />
                  </Col>
                  <Col md={6}>
                    <FormInput name="reference_location" label="Location" />
                  </Col>
                </Row>
              </div>
            )}
            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <h4>Please Upload Clear Copy</h4>
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="photo"
                        className="document-label required"
                      >
                        Photo(Selfie)
                      </label>
                      <div className="document-file-container">
                        <input
                          name="photo"
                          label="Photo"
                          type="file"
                          className="form-control-file"
                          {...methods.register("photo", {
                            required: "Photo is required",
                            onChange: (e) => handleFileChange(e), // merge your custom onChange
                          })}
                          ref={(e) => {
                            methods.register("photo").ref(e); // react-hook-form ref
                            fileRefs.photo.current = e;
                          }}
                        />
                        {files.photo && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("photo")}
                          />
                        )}
                      </div>
                      {errors.photo && (
                        <span className="error-message">
                          {errors.photo.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="aadhar_card"
                        className="document-label required"
                      >
                        Aadhaar/eAadhaar
                      </label>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="aadhar_card"
                          name="aadhar_card"
                          className="form-control-file"
                          {...methods.register("aadhar_card", {
                            required: "Aadhaar Card is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("aadhar_card").ref(e);
                            fileRefs.aadhar_card.current = e;
                          }}
                        />
                        {files.aadhar_card && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("aadhar_card")}
                          />
                        )}
                      </div>
                      {errors.aadhar_card && (
                        <span className="error-message">
                          {errors.aadhar_card.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="pan_card"
                        className="document-label required"
                      >
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          id="pan_card"
                          name="pan_card"
                          type="file"
                          className="form-control-file"
                          {...methods.register("pan_card", {
                            required: "PAN Card is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("pan_card").ref(e);
                            fileRefs.pan_card.current = e;
                          }}
                        />
                        {files.pan_card && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pan_card")}
                          />
                        )}
                      </div>
                      {errors.pan_card && (
                        <span className="error-message">
                          {errors.pan_card.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="salaried_account_statement"
                        className="document-label required"
                      >
                      {watch("work_type") === "Salaried" ? (
                          <>
                            Account Statement <br /> (Last 6 Months)
                          </>
                        ) : (
                          <>
                            Account Statement <br /> (Last 12 Months)
                          </>
                        )}
                      </label>
                      <div className="document-file-container">
                        <input
                          id="salaried_account_statement"
                          name="salaried_account_statement"
                          type="file"
                          className="form-control-file"
                          accept=".pdf"
                          {...methods.register("salaried_account_statement", {
                            required: "Account Statement is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("salaried_account_statement").ref(e);
                            fileRefs.salaried_account_statement.current = e;
                          }}
                        />
                        {files.salaried_account_statement && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("salaried_account_statement")}
                          />
                        )}
                      </div>
                      {errors.salaried_account_statement && (
                        <span className="error-message">
                          {errors.salaried_account_statement.message}
                        </span>
                      )}
                    </div>
                    {watch("work_type") === "Salaried" && (
                      <>
                        <div className="document-upload-group create-document">
                          <label htmlFor="payslip" className="document-label">
                            Pay Slip (Last 3 Months)
                          </label>
                          <div className="document-file-container">
                            <input
                              id="payslip"
                              name="payslip"
                              type="file"
                              className="form-control-file"
                              {...methods.register("payslip", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("payslip").ref(e);
                                fileRefs.payslip.current = e;
                              }}
                            />
                            {files.payslip && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("payslip")}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {watch("work_type") === "Own Clinic" && (
                      <>
                        <div className="document-upload-group create-document">
                          <label
                            htmlFor="itr"
                            className="document-label"
                          >
                            ITR Last 2 Years
                          </label>
                          <div className="document-file-container">
                            <input
                              id="itr"
                              name="itr"
                              type="file"
                              className="form-control-file"
                              {...methods.register("itr", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("itr").ref(e);
                                fileRefs.itr.current = e;
                              }}
                            />
                            {files.itr && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("itr")}
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <label
                            htmlFor="clinic_registration_certificate"
                            className="document-label"
                          >
                            Clinic Registeration
                          </label>
                          <div className="document-file-container">
                            <input
                              id="clinic_registration_certificate"
                              name="clinic_registration_certificate"
                              type="file"
                              className="form-control-file"
                              {...methods.register("clinic_registration_certificate", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("clinic_registration_certificate").ref(e);
                                fileRefs.clinic_registration_certificate.current = e;
                              }}
                            />
                            {files.clinic_registration_certificate && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("clinic_registration_certificate")}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="degree_certificate"
                        className="document-label"
                      >
                        Degree Certificate
                      </label>
                      <div className="document-file-container">
                        <input
                          id="degree_certificate"
                          name="degree_certificate"
                          label="Degree Certificate"
                          type="file"
                          className="form-control-file"
                          {...methods.register("degree_certificate", {
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("degree_certificate").ref(e);
                            fileRefs.degree_certificate.current = e;
                          }}
                        />
                        {files.degree_certificate && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("degree_certificate")}
                          />
                        )}
                      </div>
                    </div>
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="ima_certificate"
                        className="document-label"
                      >
                        IMA Registration
                      </label>
                      <div className="document-file-container">
                        <input
                          id="ima_certificate"
                          name="ima_certificate"
                          label="IMA/Register Certificate"
                          className="form-control-file"
                          type="file"
                          {...methods.register("ima_certificate", {
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("ima_certificate").ref(e);
                            fileRefs.ima_certificate.current = e;
                          }}
                        />
                        {files.ima_certificate && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("ima_certificate")}
                          />
                        )}
                      </div>
                    </div>
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="others"
                        className="document-label"
                      >
                        Others
                      </label>
                      <div className="document-file-container">
                        <input
                          id="others"
                          name="others"
                          type="file"
                          className="form-control-file"
                          {...methods.register("others", {
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("others").ref(e);
                            fileRefs.others.current = e;
                          }}
                        />
                        {files.others && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("others")}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container mt-4 text-center">
            {activeStep > 0 && (
              <Button
                variant="secondary"
                onClick={() => handleStepChange(activeStep - 1)}
                className="custom-back-button me-2"
              >
                Go Back
              </Button>
            )}
            {activeStep < steps.length - 1 && (
              <Button
                variant="primary"
                onClick={handleNextStep}
                className="custom-next-button me-2"
              >
                Next
              </Button>
            )}
            {activeStep === steps.length - 1 && (
              <Button
                variant="success"
                type="submit"
                className="custom-submit-button"
              >
                {loading ? "Processing..." : "Submit"}
              </Button>
            )}
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default CreateDoctorForm;